import { type LoaderFunctionArgs, json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { Ol } from '#app/components/typography/ol.tsx'
import { Ul } from '#app/components/typography/ul.tsx'
import { sessionKey } from '#app/utils/auth.server.ts'
import { prisma } from '#app/utils/db.server.ts'
import { authSessionStorage } from '#app/utils/session.server.ts'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Ol',
}

const component: componentProps = {
	name: 'Ol',
	shortName: 'Ol',
	fileName: 'ol',
	category: 'typography',
	description: ['An ordered list of items.'],
	features: ['Drop-in replacement for the native <ol> element.'],
	parts: [
		{
			name: 'Ol',
			description: 'An ordered list of items.',
		},
	],
	usage: `<Ul>
	<li>Milk</li>
	<li>
		Cheese
		<Ol>
			<li>Blue cheese</li>
			<li>Feta</li>
		</Ol>
	</li>
</Ul>`,
	styling: `/* ### Typography ### */
@layer components {
	/* Ol */
	.ol {
		@apply ml-space-10 list-decimal;
	}
}`,
}

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const authSession = await authSessionStorage.getSession(request.headers.get('cookie'))
	const sessionId = authSession.get(sessionKey)
	const session =
		sessionId ?
			await prisma.session.findUnique({
				select: { user: { select: { id: true, paid: true } } },
				where: { id: sessionId, expirationDate: { gt: new Date() } },
			})
		:	null
	const source = session?.user.paid ? await readSource({ category: component.category, fileName: component.fileName }) : null
	return json({ source })
}

const SpanRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Features features={features} />
			<Parts parts={parts} />
			<Usage usage={usage} shortName={shortName} />
			<Ul>
				<li>Milk</li>
				<li>
					Cheese
					<Ol>
						<li>Blue cheese</li>
						<li>Feta</li>
					</Ol>
				</li>
			</Ul>
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default SpanRoute
